export enum IActionTypesColetaNoCd {
  'LOAD_REQUEST' = '@coletanocd/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@coletanocd/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@coletanocd/LOAD_FAILURE',

  'FILTER_COLETACD' = '@coletanocd/FILTER_COLETACD',
  'SORTER_COLETACD' = '@coletanocd/SORTER_COLETACD',
  'CLEAN_COLETANOCD' = '@coletanocd/CLEAN_COLETANOCD',
}

export interface IPaginationColetaNoCd {
  total: number;
  pageSize: number;
  current: number;
  showSizeChanger: boolean;
  pageSizeOptions: string[];
}

export interface IColetaNoCd {
  nuNotaPedido: number;
  numPedido: number;
  nunotaNF: number;
  numNF: number;
  pesoBruto: number;
  valor: number;
  cidadeUf: string;
  cliente: string;
  transportadora: string;
  crossdock: boolean;
  dtEmissao: Date | string;
  codFornecedor: number;
  fornecedor: string;
}

export interface IFilter {
  codParceiro: number;
  codTransportadora: number;
  codCidade: number;
  codEstado: number;
  nuNota: number[];
  nuNotaEmitida: number;
  dataInicio: Date | string;
  dataFim: Date | string;
}

export interface IFilterColetaNoCd {
  filter: IFilter | undefined;
}

export interface ColetaNoCdState {
  readonly data: IColetaNoCd[];
  readonly loading: boolean;
  readonly error: boolean;
  readonly pagination: IPaginationColetaNoCd;
  readonly filter: IFilter | undefined;
  readonly sorter?: any;
}
